import { useState, useEffect } from 'react';
import { systemApi } from '../api/endpoints';
import { Button } from '../components/ui/Button';
import PageHeader from '../components/ui/PageHeader';
import SpotlightCard from '../components/ui/SpotlightCard';

export default function System() {
  const [activeTab, setActiveTab] = useState<'health' | 'debug' | 'redis'>('health');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>({ health: null, debug: null, redis: null, api: null });

  const loadData = async () => {
    setLoading(true);
    try {
      const responses = await Promise.allSettled([
        systemApi.getHealth(),
        systemApi.getDebugInfo(),
        systemApi.getRedisStatus(),
        systemApi.getApiInfo(),
      ]);
      setData({
        health: responses[0].status === 'fulfilled' ? responses[0].value.data : null,
        debug: responses[1].status === 'fulfilled' ? responses[1].value.data : null,
        redis: responses[2].status === 'fulfilled' ? responses[2].value.data : null,
        api: responses[3].status === 'fulfilled' ? responses[3].value.data : null,
      });
    } catch (err) {
      console.error('Failed to load system data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="w-full">
      <PageHeader
        title="系统调试"
        actions={
          <Button variant="default" onClick={loadData} disabled={loading}>
            <span className={loading ? 'animate-spin' : ''}>↻</span> 刷新
          </Button>
        }
      />

      <div className="mb-6 flex gap-2">
        {(['health','debug','redis'] as const).map((t) => (
          <button
            key={t}
            onClick={() => setActiveTab(t)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${activeTab === t ? 'bg-white/10 text-white' : 'bg-white/5 text-white/60 hover:bg-white/10 hover:text-white'}`}
          >
            {t === 'health' ? '健康状态' : t === 'debug' ? '调试信息' : 'Redis状态'}
          </button>
        ))}
      </div>

      {activeTab === 'health' && data.health && (
        <SpotlightCard className="p-6" enablePhysics={true}>
          <h3 className="text-lg font-semibold text-white mb-4">服务健康状态</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <dt className="text-sm text-white/40">状态</dt>
              <dd className={`text-lg font-semibold ${data.health.status === 'ok' ? 'text-green-400' : 'text-red-400'}`}>{data.health.status}</dd>
            </div>
            <div>
              <dt className="text-sm text-white/40">环境</dt>
              <dd className="text-lg font-semibold text-white">{data.health.env}</dd>
            </div>
          </div>
        </SpotlightCard>
      )}

      {activeTab === 'debug' && data.debug && (
        <SpotlightCard className="p-6" enablePhysics={true}>
          <h3 className="text-lg font-semibold text-white mb-4">调试信息</h3>
          <pre className="text-xs text-white/80 font-mono">{JSON.stringify(data.debug, null, 2)}</pre>
        </SpotlightCard>
      )}

      {activeTab === 'redis' && data.redis && (
        <SpotlightCard className="p-6" enablePhysics={true}>
          <h3 className="text-lg font-semibold text-white mb-4">Redis状态</h3>
          <pre className="text-xs text-white/80 font-mono">{JSON.stringify(data.redis, null, 2)}</pre>
        </SpotlightCard>
      )}
    </div>
  );
}
